import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Button from '../Button';
import Col from '../Col';
import Form from '../Form';
import Input from '../Input';
import Row from '../Row';
import SuiteAreas from './SuiteAreas';
import {
  setSuiteFormData,
  clearSuiteFormData,
} from 'src/store/actions/suiteForm';
import { fetchSuiteAreas, fetchPropertySuites } from 'src/store/actions/suites';
import { selectSuiteFormData } from 'src/store/selectors/suiteForm';
import { selectSuiteAreas } from 'src/store/selectors/suiteAreas';
import File from '../File';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { selectValidation } from 'src/store/selectors/Validation';
import { clearValidation } from 'src/store/actions/assets';
import { selectFormLoader } from 'src/store/selectors/FormLoader';
import { stopFormLoading } from 'src/store/actions/loader';
import Loader from '../Loader';
import { selectSuites } from 'src/store/selectors/suites';
import Select from '../Select';
import Picker from '../Picker';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';
import { getBuildingLevels } from 'src/store/actions/buildings';
import { getSuiteStatuses } from 'src/store/actions/SuiteStatus';
import CreatableSelect from 'react-select/creatable';
import * as client from '../../services/client';
import { variables } from 'src/Tenants';
import {
  checkSparkDataAvailable,
  serviceRequestTableLocalTime,
} from 'src/helpers/validationHelper';
import TextEditor from '../Editor/Editor';
import {
  onUrlImageExtensionExist,
  onCheckExtensionDocument,
  generateRandomNumber,
} from 'src/helpers/CommonHelpers';
import OtherDetails from './OtherDetails';
import { upload } from 'src/helpers/uploadDocument';
import moment from 'moment';

const SuiteForm: React.FC<any> = ({ onClose, onSaveSuite }) => {
  const dispatch = useDispatch();

  const suiteFormData = useSelector(selectSuiteFormData);
  const propertySuites = useSelector(selectSuites);
  const suiteAreas = useSelector(selectSuiteAreas);
  const validation = useSelector(selectValidation);
  const loader = useSelector(selectFormLoader);
  const user = useSelector(selectAuthenticatedUser);
  const buildingList = useSelector((state: any) => state.buildings);
  const levelList = useSelector((state: any) => state.levels);
  const suiteStatuses = useSelector((state: any) => state.suiteStatuses);

  const onSetSuiteFormData = (data: any) => dispatch(setSuiteFormData(data));
  const clearSuiteFormDataAction = () => dispatch(clearSuiteFormData());
  const fetchSuiteAreasAction = () => dispatch(fetchSuiteAreas());
  const onFetchPropertySuites = (
    propertyId: any,
    userId: any,
    roleName: any,
    flag: any
  ) => dispatch(fetchPropertySuites(propertyId, userId, roleName, flag));
  const onStopFormLoading = () => dispatch(stopFormLoading());
  const clearValidationAction = () => dispatch(clearValidation());
  const getBuildingLevelsAction = (buildingId: any) =>
    dispatch(getBuildingLevels(buildingId));
  const getSuiteStatusesAction = () => dispatch(getSuiteStatuses());

  const [state, setState] = useState<any>({
    areas: [],
    errors: {},
    buttonPressed: '',
    show: false,
    value: 1,
    suiteAreas: suiteAreas,
    floorImage:
      suiteFormData && suiteFormData.floorPlanURL
        ? suiteFormData.floorPlanURL
        : null,
    loading: false,
    editorState: suiteFormData.keyHandOffInstructions
      ? suiteFormData.keyHandOffInstructions
      : '',
  });

  useEffect(() => {
    setState((prevState: any) => ({ ...prevState, suiteAreas }));
  }, [suiteAreas]);

  useEffect(() => {
    setState((prevState: any) => ({
      ...prevState,
      floorImage:
        suiteFormData && suiteFormData.floorPlanURL
          ? suiteFormData.floorPlanURL
          : null,
    }));
  }, [suiteFormData.floorPlanURL]);

  useEffect(() => {
    setState((prevState: any) => ({
      ...prevState,
      editorState: suiteFormData.keyHandOffInstructions
        ? suiteFormData.keyHandOffInstructions
        : '',
    }));
  }, [suiteFormData.keyHandOffInstructions]);

  const onEditorChange = (editorState: any) => {
    setState((prevState: any) => ({ ...prevState, editorState }));
    onSetSuiteFormData({
      keyHandOffInstructions: editorState,
    });
  };

  useEffect(() => {
    if (suiteFormData.id && suiteFormData.keyFobs !== null) {
      const needsTransformation = suiteFormData.keyFobs.some((item: any) => {
        return !item.label || !item.value;
      });

      if (needsTransformation) {
        onSetSuiteFormData({
          keyFobs: suiteFormData.keyFobs.map((item: any) => {
            return {
              ...item,
              label: item.name,
              value: item.name,
            };
          }),
        });
      }
    }

    onAddPair();

    if (suiteFormData.propertyId) {
      onFetchPropertySuites(
        suiteFormData.propertyId,
        user.id,
        user.roles[0].role.name,
        false
      );
    }

    onStopFormLoading();
    fetchSuiteAreasAction();
    getSuiteStatusesAction();
    setState((prevState: any) => ({ ...prevState, suiteAreas }));

    if (suiteFormData.id) {
      let suiteParkingSlots = suiteFormData.parkingStalls;
      let suiteStorageLockers = suiteFormData.storageLockers;
      let suiteKeyFobs = suiteFormData.keyFobs;
      let parkingStalls: any[] = [];
      let storageLockers: any[] = [];
      let keyFobs: any[] = [];

      if (suiteParkingSlots && suiteParkingSlots.length > 0) {
        suiteParkingSlots.map((ps: any) => {
          let obj = {
            label: ps.name,
            value: ps.name,
          };
          parkingStalls = [...parkingStalls, obj];
        });
      }

      if (suiteStorageLockers && suiteStorageLockers.length > 0) {
        suiteStorageLockers.map((ps: any) => {
          let obj = {
            label: ps.name,
            value: ps.name,
          };
          storageLockers = [...storageLockers, obj];
        });
      }

      if (suiteKeyFobs && suiteKeyFobs.length > 0) {
        suiteKeyFobs.map((kf: any) => {
          let obj = {
            label: kf.name,
            value: kf.name,
          };
          keyFobs = [...keyFobs, obj];
        });
      }

      onSetSuiteFormData({
        parkingStalls: parkingStalls,
        storageLockers: storageLockers,
        keyFobs: keyFobs,
      });

      let areasData: any[] = [];
      let suiteAreasData = suiteAreas;
      let data = suiteFormData.areas;

      data.map((item: any, i: number) => {
        let object = {
          id: item.areaId,
          customLabel: item.customLabel,
          name: item.name,
        };
        areasData.push(object);
      });

      let areaData = areasData;

      for (var i = 0; i < suiteAreasData.length; i++) {
        areaData = areaData.filter((a: any) => a.id !== suiteAreasData[i].id);
      }

      areaData = areaData.map((a: any) => ({
        id: a.id,
        type: 'Other',
        customLabel: a.customLabel,
      }));

      if (areaData.length > 0) {
        if (suiteFormData.otherAreas.length > 0) {
          for (var l = 0; l < suiteFormData.otherAreas.length; l++) {
            areaData = areaData.filter(
              (a: any) => a.id !== suiteFormData.otherAreas[l].id
            );
          }
        }
      }

      let otherAreas = [...suiteFormData.otherAreas, ...areaData];

      otherAreas.map((oItem: any) => {
        let o = {
          id: oItem.id,
          type: oItem.type,
          customLabel: oItem.name,
        };

        suiteAreasData = [...suiteAreasData, o];
      });

      setState((prevState: any) => ({
        ...prevState,
        areas: areasData,
        suiteAreas: suiteAreasData,
      }));
      getBuildingLevelsAction(suiteFormData.buildingId);

      for (var i = 0; i < buildingList.length; i++) {
        if (suiteFormData.buildingId === buildingList[i].id) {
          onSetSuiteFormData({
            Building: buildingList[i].building,
            BuildingId: suiteFormData.buildingId,
            buildingName: buildingList[i].building,
          });
        }
      }
      onSetSuiteFormData({
        BuildingId: suiteFormData.buildingId,
      });
    } else {
      onSetSuiteFormData({
        ...suiteFormData,
        statusId: '00000000-0000-0000-0000-000000000000',
      });
    }
  }, []);

  useEffect(() => {
    if (validation.status === true) {
      if (validation.message === 'message') {
        clearValidationAction();
      } else if (
        validation.message === 'Success' &&
        state.buttonPressed === 'SaveAndClose'
      ) {
        setState((prevState: any) => ({
          ...prevState,
          areas: [],
          show: false,
        }));
        onClose();
        clearSuiteFormDataAction();
        clearValidationAction();
      } else if (
        validation.message === 'Success' &&
        state.buttonPressed === 'SaveAndAdd'
      ) {
        setState((prevState: any) => ({
          ...prevState,
          areas: [],
          show: false,
        }));
        clearSuiteFormDataAction();
        clearValidationAction();
      }
    }
  }, [validation.status, validation.message, state.buttonPressed]);

  useEffect(() => {
    if (levelList.length > 0) {
      if (suiteFormData.levelId) {
        for (var i = 0; i < levelList.length; i++) {
          if (levelList[i].id === suiteFormData.levelId) {
            onSetSuiteFormData({
              LevelId: suiteFormData.levelId,
              Level: levelList[i].level,
              levelName: levelList[i].level,
            });
          }
        }
      }
    }

    if (
      levelList.length > 0 &&
      !suiteFormData.LevelId &&
      !suiteFormData.Level &&
      suiteFormData.BuildingId
    ) {
      if (suiteFormData.levelId) {
        for (var i = 0; i < levelList.length; i++) {
          if (levelList[i].id === suiteFormData.levelId) {
            onSetSuiteFormData({
              LevelId: suiteFormData.levelId,
              Level: levelList[i].level,
              levelName: levelList[i].level,
            });
          }
        }
      }
    }
  }, [
    levelList,
    suiteFormData.levelId,
    suiteFormData.LevelId,
    suiteFormData.Level,
    suiteFormData.BuildingId,
  ]);

  const onSave = (suiteFormData: any, actionType: string) => {
    setState((prevState: any) => ({ ...prevState, buttonPressed: actionType }));

    let areasData = state.areas.filter((item: any) => item.other !== 'Other');
    let suiteData = propertySuites.find(
      (data: any) => data.id === suiteFormData.fromUnitId
    );

    let others =
      suiteData && suiteData.otherAreas && suiteData.otherAreas.length > 0
        ? suiteData.otherAreas
        : [];

    if (
      suiteFormData &&
      suiteFormData.copyFormExistingSuite &&
      suiteFormData.copyFormExistingSuite === true
    ) {
      if (others.length > 0) {
        for (var l = 0; l < others.length; l++) {
          for (var m = 0; m < areasData.length; m++) {
            if (areasData[m].id === others[l].id) {
              areasData[m] = {
                type: 'Other',
                customLabel: areasData[m].customLabel,
              };
            }
          }
        }
      }
    }

    let keyfobs =
      suiteFormData.keyFobs && suiteFormData.keyFobs.length > 0
        ? suiteFormData.keyFobs.map((item: any) => {
            return {
              Name: item.value,
            };
          })
        : [];

    const suiteKeysAndValues =
      suiteFormData.suiteKeysAndValues &&
      suiteFormData.suiteKeysAndValues.length > 0
        ? suiteFormData.suiteKeysAndValues
        : [];

    const filtered = suiteKeysAndValues.filter(function (el: any) {
      return el.key?.trim() && el.value?.trim();
    });

    const updatedData = filtered.map(({ id, ...rest }: any) => rest);

    let formData = {
      ...suiteFormData,
      keyFobs: keyfobs,
      suiteKeysAndValues: updatedData,
    };

    onSaveSuite(formData, areasData, state.floorImage);
    onClose();
  };

  const handleAreas = (id: any, value: any, area: any) => {
    let areasData = state.areas;
    let suiteAreasData = state.suiteAreas;
    let index = areasData.findIndex((data: any) => data.id === id);

    if (index === -1) {
      let object;
      if (area.name === 'Other') {
        object = {
          id: id,
          other: area.name,
        };
      } else {
        object = {
          id: id,
          name: area.name,
        };
      }
      areasData.push(object);
    } else {
      areasData.splice(index, 1);
      if ((value && value.type) || (area && area.type)) {
        let filteredData = suiteAreasData.filter((data: any) => data.id !== id);
        setState((prevState: any) => ({
          ...prevState,
          suiteAreas: filteredData,
        }));
      }
    }

    setState((prevState: any) => ({ ...prevState, areas: [...areasData] }));
  };

  const onAddArea = (id: any) => {
    let areasData = state.areas;
    let suiteAreasData = state.suiteAreas;
    let data: any = areasData.filter((item: any) => item.id === id);

    if (data.length > 0) {
      if (data[0] && data[0].customLabel && data[0].customLabel.trim()) {
        let obj: any = {
          id: (state.value + 1).toString(),
          otherAreaId: id,
          customLabel: data[0].customLabel.trim(),
        };
        suiteAreasData = [...suiteAreasData, obj];
        obj = { ...obj, type: 'Other' };
        areasData = [...areasData, obj];

        let filtereddata = areasData.filter(
          (object: any) => object.other !== 'Other'
        );
        setState((prevState: any) => ({
          ...prevState,
          value: state.value + 1,
          suiteAreas: suiteAreasData,
          areas: filtereddata,
        }));
      } else {
        let filtereddata = areasData.filter(
          (object: any) => object.other !== 'Other'
        );
        setState((prevState: any) => ({
          ...prevState,
          suiteAreas: suiteAreasData,
          areas: filtereddata,
        }));
      }
    }
  };

  const onEnterText = (text: string, id: any) => {
    let areasData = state.areas;
    let index = areasData.findIndex((data: any) => data.id === id);

    if (index !== -1) {
      areasData[index].customLabel = text;
    }

    setState((prevState: any) => ({ ...prevState, areas: [...areasData] }));
  };

  const onValidateFile = async (file: any) => {
    let errorsData = state.errors;
    let path = file[0].path;

    if (file && file.length > 0) {
      if (onUrlImageExtensionExist(path)) {
        onSetSuiteFormData({ floorPlanURL: file });
        setState((prevState: any) => ({ ...prevState, floorImage: '' }));
        errorsData['floorPlanURL'] = '';
        setState((prevState: any) => ({
          ...prevState,
          errors: { ...errorsData },
        }));
      } else {
        onSetSuiteFormData({ floorPlanURL: file });
        setState((prevState: any) => ({ ...prevState, floorImage: '' }));
        toast.success(
          'Your document upload has started, it may take some time.',
          {
            autoClose: 5000,
            position: 'top-center',
          }
        );
        let newFileName =
          path.split(/\.(?=[^\.]+$)/)[0] +
          moment().format('MMDDYYYYhmmss') +
          '.' +
          path.split(/\.(?=[^\.]+$)/)[1];
        let image = await upload(file[0], newFileName.replace(/ /g, ''));
        setState((prevState: any) => ({ ...prevState, floorImage: image }));
      }
    } else {
      toast.error(
        ' 🚫 You have uploaded an invalid file format, allowed formats are JPG or PNG or PDF',
        { autoClose: 12000, position: 'top-center' }
      );
    }
  };

  const getPropertySuites = () => {
    setState((prevState: any) => ({ ...prevState, show: true }));
  };

  const handleSelectedSuite = async (e: any) => {
    let id = e.target.value;
    let suiteData = propertySuites.find((data: any) => data.id === id);

    if (suiteData && suiteData.id) {
      clearSuiteFormDataAction();
      setState((prevState: any) => ({
        ...prevState,
        floorImage: suiteData.floorPlanURL,
      }));
      onSetAreas(suiteData);
      onSetSuiteFormData({
        copyFormExistingSuite: true,
        fromUnitId: suiteData.id,
        propertyId: suiteData.propertyId,
        number: suiteFormData.number,
        statusId: suiteFormData.statusId,
        stratalot: suiteData && suiteData.stratalot ? suiteData.stratalot : '',
        assetWarrantyDefaultStartDate:
          suiteData && suiteData.assetWarrantyDefaultStartDate
            ? suiteData && suiteData.assetWarrantyDefaultStartDate
            : null,
        floorPlanURL:
          suiteData && suiteData.floorPlanURL ? suiteData.floorPlanURL : null,
      });

      onAddPair();
    }
  };

  const handleSelectedStatus = async (e: any) => {
    let id = e.target.value;

    onSetSuiteFormData({
      statusId: id,
    });
  };

  const onSetAreas = (suiteData: any) => {
    let areasData: any[] = [];
    let suiteAreasData = suiteAreas;
    let data = suiteData.areas;

    data.map((item: any, i: number) => {
      let object = {
        id: item.areaId,
        customLabel: item.customLabel,
      };
      areasData.push(object);
    });

    let otherAreas = suiteData.otherAreas;

    otherAreas.map((oItem: any) => {
      let o = {
        id: oItem.id,
        type: oItem.type,
        customLabel: oItem.name,
      };
      suiteAreasData = [...suiteAreasData, o];
    });

    setState((prevState: any) => ({
      ...prevState,
      areas: areasData,
      suiteAreas: suiteAreasData,
    }));
  };

  const onChangeBuilding = (object: any) => {
    onSetSuiteFormData({
      Building: object.building,
      BuildingId: object.id,
      buildingName: object.building,
    });
    getBuildingLevelsAction(object.id);
    setState((prevState: any) => ({
      ...prevState,
      displayBuildingItem: false,
      isChanged: false,
    }));
  };

  const onChangeLevel = (object: any) => {
    onSetSuiteFormData({
      LevelId: object.id,
      Level: object.level,
      levelName: object.level,
    });
    setState((prevState: any) => ({
      ...prevState,
      displayLevelItem: false,
      isChanged: false,
      isLevelChanged: false,
    }));
  };

  const onCheckExistingParkingStallStorageLockers = (
    newValue: any,
    latestValue: any,
    type: string
  ) => {
    if (latestValue && latestValue.option && latestValue.option.value) {
      setState((prevState: any) => ({ ...prevState, loading: true }));
      client
        .CheckExistingParkingStallStorageLockers(
          suiteFormData.propertyId,
          latestValue.option.value,
          type === 'parkingStalls' ? 'ParkingStalls' : 'StorageLockers'
        )
        .then((response: any) => {
          setState((prevState: any) => ({ ...prevState, loading: false }));

          if (response.status === 200) {
            response.json().then((responseJson: any) => {
              if (responseJson !== true) {
                if (type === 'parkingStalls') {
                  onSetSuiteFormData({ parkingStalls: newValue });
                } else {
                  onSetSuiteFormData({ storageLockers: newValue });
                }
              } else {
                if (type === 'parkingStalls') {
                  toast.error('This Parking stall is not available.', {
                    autoClose: 12000,
                    position: 'top-center',
                  });
                } else {
                  toast.error('This Storage locker is not available.', {
                    autoClose: 12000,
                    position: 'top-center',
                  });
                }
              }
            });
          } else {
            toast.error('Some thing went wrong with the slot validation.', {
              autoClose: 12000,
              position: 'top-center',
            });
          }
        })
        .catch(() => {
          toast.error('Some thing went wrong with the slot validation.', {
            autoClose: 12000,
            position: 'top-center',
          });

          setState((prevState: any) => ({ ...prevState, loading: false }));
        });
    } else {
      if (type === 'parkingStalls') {
        onSetSuiteFormData({ parkingStalls: newValue });
      } else {
        onSetSuiteFormData({ storageLockers: newValue });
      }
    }
  };

  const onAddPair = () => {
    const suiteKeysAndValues = suiteFormData.suiteKeysAndValues
      ? suiteFormData.suiteKeysAndValues
      : [];

    onSetSuiteFormData({
      suiteKeysAndValues: [
        ...suiteKeysAndValues,
        {
          id: generateRandomNumber(),
          key: '',
          value: '',
        },
      ],
    });
  };

  const onRemovePair = (item: any) => {
    const suiteKeysAndValues = suiteFormData.suiteKeysAndValues
      ? suiteFormData.suiteKeysAndValues
      : [];

    let updatedData = suiteKeysAndValues.filter(
      (object: any) => object.id !== item.id
    );

    onSetSuiteFormData({
      suiteKeysAndValues: updatedData,
    });
  };

  const onInputChange = (value: any, item: any, property: string) => {
    let suiteKeysAndValues = suiteFormData.suiteKeysAndValues;
    let updatedData = suiteKeysAndValues.map((object: any) => {
      if (object.id === item.id) {
        return { ...item, [property]: value };
      }

      return object;
    });

    onSetSuiteFormData({
      suiteKeysAndValues: updatedData,
    });
  };

  const suiteKeysAndValues =
    suiteFormData.suiteKeysAndValues &&
    suiteFormData.suiteKeysAndValues.length > 0
      ? suiteFormData.suiteKeysAndValues
      : [];

  console.log('=====DEPLOYMENT CHECKING===');

  return (
    <Form
      headline={
        (suiteFormData && suiteFormData.id ? 'Edit' : 'Add') +
        ' ' +
        variables.Suite
      }
      onClose={onClose}
      actions={
        <>
          {loader || state.loading ? <Loader center={true} /> : null}
          <div />

          {suiteFormData && suiteFormData.id ? (
            <div />
          ) : (
            <Button
              color="teal"
              size="small"
              label="Copy from Existing"
              onClick={() => getPropertySuites()}
            />
          )}
          {suiteFormData && suiteFormData.id ? (
            <div />
          ) : (
            <Button
              color="semantics"
              size="small"
              label="Save and Add Another"
              disabled={
                (suiteFormData && suiteFormData.number
                  ? !suiteFormData.number.trim()
                  : !suiteFormData.number) ||
                (state.show ? !suiteFormData.fromUnitId : false) ||
                !state.areas.length ||
                suiteFormData.statusId ===
                  '00000000-0000-0000-0000-000000000000'
              }
              onClick={() => onSave(suiteFormData, 'SaveAndAdd')}
            />
          )}

          <Button
            color="teal"
            size="small"
            label={'Save ' + variables.Suite}
            disabled={
              (suiteFormData && suiteFormData.number
                ? !suiteFormData.number.trim()
                : !suiteFormData.number) ||
              (state.show ? !suiteFormData.fromUnitId : false) ||
              !state.areas.length ||
              suiteFormData.statusId === '00000000-0000-0000-0000-000000000000'
            }
            onClick={() => onSave(suiteFormData, 'SaveAndClose')}
          />
        </>
      }
      component={
        <>
          <h2 style={{ marginTop: '5%' }}>{`${variables.Suite} Details`}</h2>
          <Row>
            <Col xs="12" md="6">
              <Input
                value={suiteFormData.number ? suiteFormData.number : ''}
                onChange={(e: any) =>
                  onSetSuiteFormData({ number: e.target.value })
                }
                label={
                  variables.Suite === 'Suite'
                    ? variables.Suite + ' Number :'
                    : variables.Suite + ''
                }
                placeholder={
                  variables.Suite === 'Suite'
                    ? variables.Suite + ' Number'
                    : variables.Suite + ''
                }
                block
                required={true}
                disabled={checkSparkDataAvailable(
                  suiteFormData,
                  user.roles[0].role.name
                )}
              />
            </Col>
            <Col xs="12" md="6">
              <Input
                value={
                  suiteFormData.warrantyAddress
                    ? suiteFormData.warrantyAddress
                    : ''
                }
                onChange={(e: any) =>
                  onSetSuiteFormData({ warrantyAddress: e.target.value })
                }
                label="Warranty/Civic Address :"
                placeholder="Warranty/Civic Address"
                block
              />
            </Col>
          </Row>
          <Row>
            <Col xs="6" md="6">
              <Select
                value={
                  suiteFormData.statusId !==
                  '00000000-0000-0000-0000-000000000000'
                    ? suiteFormData.statusId
                    : ''
                }
                onChange={(e: any) => handleSelectedStatus(e)}
                options={suiteStatuses.map((status: any) => ({
                  value: status.id,
                  label: status.name,
                }))}
                label="Status"
                placeholder="(Select status)"
                disabled={checkSparkDataAvailable(
                  suiteFormData,
                  user.roles[0].role.name
                )}
                block
              />
            </Col>
          </Row>
          <Row>
            <Col xs="12" md="12">
              <File
                label="Floorplan"
                description="Upload photos (JPG or PNG or PDF)."
                onSelect={(file: any) =>
                  onCheckExtensionDocument(file) && onValidateFile(file)
                }
                files={
                  state.floorImage === suiteFormData.floorPlanURL
                    ? []
                    : !!suiteFormData.floorPlanURL &&
                        suiteFormData.floorPlanURL.length > 0 &&
                        !suiteFormData.floorPlanURL[0].path.includes('.pdf')
                      ? suiteFormData.floorPlanURL
                      : []
                }
                image={
                  state.floorImage && state.floorImage.includes('.pdf')
                    ? null
                    : state.floorImage
                }
                errors={state.errors.floorPlanURL}
              />
              {state.floorImage && state.floorImage.includes('.pdf') && (
                <a href={state.floorImage} target="_blank">
                  {state.floorImage.split('.com/')[1]}
                </a>
              )}
            </Col>
          </Row>
          {state.show ? (
            <Select
              value={suiteFormData.fromUnitId ? suiteFormData.fromUnitId : ''}
              onChange={(e: any) => handleSelectedSuite(e)}
              options={propertySuites.map((suite: any) => ({
                value: suite.id,
                label: suite.number,
              }))}
              label="Copy from Existing"
              placeholder={`(Select ${variables.Suite})`}
              block
            />
          ) : null}
          <h2 style={{ marginTop: '2%' }}>Property Details</h2>
          <Row>
            <Col xs="12" md="6">
              <Input
                value={suiteFormData.stratalot ? suiteFormData.stratalot : ''}
                onChange={(e: any) =>
                  onSetSuiteFormData({ stratalot: e.target.value })
                }
                label="Strata Lot :"
                placeholder="Strata Lot"
                block
                disabled={checkSparkDataAvailable(
                  suiteFormData,
                  user.roles[0].role.name
                )}
              />
            </Col>
            <Col xs="12" md="6">
              <Input
                value={
                  state.isChanged
                    ? suiteFormData.buildingName
                    : suiteFormData.building && suiteFormData.building.id
                      ? suiteFormData.building.name
                      : suiteFormData.buildingId
                        ? suiteFormData.buildingName
                        : suiteFormData.buildingName
                }
                onChange={(e: any) => {
                  onSetSuiteFormData({
                    buildingName: e?.target?.value,
                    Building: e?.target?.value,
                    BuildingId: null,
                  });

                  setState((prevState: any) => ({
                    ...prevState,
                    displayBuildingItem: true,
                    isChanged: true,
                    buildingSearch: e?.target?.value,
                  }));
                }}
                label="Buildings :"
                placeholder="Start typing the Building's name to choose one"
                block
                disabled={checkSparkDataAvailable(
                  suiteFormData,
                  user.roles[0].role.name
                )}
              />
              {state.displayBuildingItem ? (
                <Col>
                  {state.buildingSearch
                    ? buildingList
                        .filter(
                          ({ building }: any) =>
                            building
                              .toLowerCase()
                              .indexOf(state.buildingSearch.toLowerCase()) > -1
                        )
                        .map((value: any, i: number) => {
                          return (
                            <div
                              onClick={() => onChangeBuilding(value)}
                              className="input__autoComplete"
                              key={i}
                            >
                              <span>{value.building}</span>
                            </div>
                          );
                        })
                    : null}
                </Col>
              ) : null}
            </Col>
            <Col xs="12" md="6">
              <Input
                value={
                  state.isLevelChanged
                    ? suiteFormData.levelName
                    : suiteFormData.level && suiteFormData.level.id
                      ? suiteFormData.level.name
                      : suiteFormData.levelId
                        ? suiteFormData.levelName
                        : suiteFormData.levelName
                }
                onChange={(e: any) => {
                  onSetSuiteFormData({
                    levelName: e?.target?.value,
                    Level: e?.target?.value,
                    LevelId: null,
                  });
                  setState((prevState) => ({
                    ...prevState,
                    displayLevelItem: true,
                    isLevelChanged: true,
                    levelSearch: e?.target?.value,
                  }));
                }}
                label="Level :"
                placeholder="Start typing the Level's name to choose one"
                block
              />
              {state.displayLevelItem ? (
                <Col>
                  {state.levelSearch
                    ? levelList
                        .filter(
                          ({ level }: any) =>
                            level &&
                            level
                              .toLowerCase()
                              .indexOf(state.levelSearch.toLowerCase()) > -1
                        )
                        .map((value: any, i: number) => {
                          return (
                            <div
                              onClick={() => onChangeLevel(value)}
                              className="input__autoComplete"
                              key={i}
                            >
                              <span>{value.level}</span>
                            </div>
                          );
                        })
                    : null}
                </Col>
              ) : null}
            </Col>
          </Row>
          <Row>
            <Col xs="12" md="6">
              <Row>
                <div style={{ marginLeft: 16, marginTop: 10 }}>
                  <label className="file__label">Parking Stalls :</label>
                </div>
              </Row>
              <div>
                <CreatableSelect
                  placeholder="Enter Parking Stall"
                  isClearable
                  isMulti
                  value={
                    suiteFormData.parkingStalls
                      ? suiteFormData.parkingStalls
                      : []
                  }
                  onChange={(newValue: any, actionMeta: any) =>
                    onCheckExistingParkingStallStorageLockers(
                      newValue,
                      actionMeta,
                      'parkingStalls'
                    )
                  }
                  isDisabled={checkSparkDataAvailable(
                    suiteFormData,
                    user.roles[0].role.name
                  )}
                />
              </div>
            </Col>
            <Col xs="12" md="6">
              <Row>
                <div style={{ marginLeft: 16, marginTop: 10 }}>
                  <label className="file__label">Storage Lockers :</label>
                </div>
              </Row>
              <div style={{ marginBottom: 10 }}>
                <CreatableSelect
                  placeholder="Enter Storage Locker"
                  isClearable
                  isMulti
                  value={
                    suiteFormData.storageLockers
                      ? suiteFormData.storageLockers
                      : []
                  }
                  onChange={(newValue: any, actionMeta: any) =>
                    onCheckExistingParkingStallStorageLockers(
                      newValue,
                      actionMeta,
                      'storageLockers'
                    )
                  }
                  isDisabled={checkSparkDataAvailable(
                    suiteFormData,
                    user.roles[0].role.name
                  )}
                />
              </div>
            </Col>
            <Col xs="12" md="6">
              <Row>
                <div style={{ marginLeft: 16, marginTop: 10 }}>
                  <label className="file__label">Key Fobs Assignment :</label>
                </div>
              </Row>
              <div>
                <CreatableSelect
                  value={suiteFormData.keyFobs ? suiteFormData.keyFobs : []}
                  onChange={(e: any) => onSetSuiteFormData({ keyFobs: e })}
                  isClearable
                  isMulti
                />
              </div>
            </Col>
            <Col xs="12" md="6" style={{ marginTop: 10 }}>
              <Input
                value={
                  suiteFormData.numberOfKeys ? suiteFormData.numberOfKeys : ''
                }
                onChange={(e: any) =>
                  onSetSuiteFormData({ numberOfKeys: e.target.value })
                }
                label="Number of Physical Keys :"
                block
              />
            </Col>
          </Row>
          <OtherDetails
            keyValuePairs={suiteKeysAndValues}
            onInputChange={onInputChange}
            onAddPair={onAddPair}
            onRemovePair={onRemovePair}
          />
          <Row style={{ marginTop: '5px' }}>
            <Col xs="12" md="12">
              <div className="input">
                <div className="input__require">
                  <label className="input__label">
                    Key Pickup Instructions :
                  </label>
                </div>
                <div
                  style={{
                    borderBottom: '0.1rem solid rgba(83, 83, 83, 0.25)',
                  }}
                  className="input__control"
                >
                  <TextEditor
                    editorState={state.editorState}
                    onEditorStateChange={onEditorChange}
                  />
                </div>
              </div>
            </Col>
          </Row>
          <h2 style={{ marginTop: '2%' }}>Warranty Details</h2>
          <Row>
            <Col xs="12" md="6">
              <Picker
                label="Asset Warranty Default Start Date"
                placeholderText="Choose Date"
                showPopperArrow={false}
                selected={
                  suiteFormData && suiteFormData.assetWarrantyDefaultStartDate
                    ? new Date(
                        serviceRequestTableLocalTime(
                          suiteFormData.assetWarrantyDefaultStartDate,
                          'suiteform'
                        )
                      )
                    : null
                }
                onChange={(date: any) => {
                  onSetSuiteFormData({ assetWarrantyDefaultStartDate: date });
                }}
                required={undefined}
              />
            </Col>
            <Col xs="12" md="6">
              <Input
                value={
                  suiteFormData.warrantyNumber
                    ? suiteFormData.warrantyNumber
                    : ''
                }
                onChange={(e: any) =>
                  onSetSuiteFormData({ warrantyNumber: e.target.value })
                }
                label="Warranty Number :"
                placeholder="Warranty Number"
                block
              />
            </Col>
          </Row>
          <Row>
            <div style={{ marginLeft: 10 }}>
              <label className="file__label">
                <h2>
                  {' '}
                  {'Rooms/Areas in ' + variables.Suite}
                  <span style={{ color: 'red', marginLeft: '2px' }}>*</span>
                </h2>
              </label>
            </div>
          </Row>
          <Row>
            {state.suiteAreas.map((sAreas: any, i: number) => {
              let value = state.areas.find(
                (data: any) => data.id === sAreas.id
              );
              return (
                <Col xs="12" md="6" key={i}>
                  <SuiteAreas
                    label={sAreas.name}
                    type="checkbox"
                    id={sAreas.id}
                    value={value && value.id ? value.id : null}
                    textValue={
                      value && value.customLabel ? value.customLabel : ''
                    }
                    disabled={
                      !(
                        !checkSparkDataAvailable(
                          suiteFormData,
                          user.roles[0].role.name
                        ) && value
                      )
                    }
                    onInputChange={(e: any) =>
                      onEnterText(e.target.value, sAreas.id)
                    }
                    onChange={(e: any) =>
                      handleAreas(e.target.id, value, sAreas)
                    }
                    isSpark={checkSparkDataAvailable(
                      suiteFormData,
                      user.roles[0].role.name
                    )}
                    onAddArea={() => onAddArea(sAreas.id)}
                    checked={undefined}
                  />
                </Col>
              );
            })}
          </Row>
        </>
      }
      footer={undefined}
      onSubmit={undefined}
      strapline={undefined}
      onExit={undefined}
    />
  );
};

export default SuiteForm;
